module.exports = __webpack_public_path__ + "static/media/G-sharp-Triads.7748cd20.png";